import { render, staticRenderFns } from "./ModalLogDetalhes.vue?vue&type=template&id=27a32d52"
import script from "./ModalLogDetalhes.vue?vue&type=script&lang=js"
export * from "./ModalLogDetalhes.vue?vue&type=script&lang=js"
import style0 from "./ModalLogDetalhes.vue?vue&type=style&index=0&id=27a32d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports